<template>
  <v-container>
    <p>Lançamentos contabilidade</p>
    <div class="" style="display: flex; justify-content: start">
      <v-select
        class="mx-4"
        style="width: 200px"
        :items="filiais"
        label="Filial"
        placeholder="Filial"
        persistent-placeholder
        clearable
        v-model="selectedFilial"
      ></v-select>

      <div class="mx-4">
        <DateInput v-model="anomesDate" label="Mês de referência"></DateInput>
      </div>
      <div class="mx-4">
        <DateInputDate
          v-model="lastDate"
          label="Data do lote"
          type="date"
        ></DateInputDate>
      </div>

      <v-btn
        :disabled="loading"
        @click="ctb(selectedFilial)"
        class="primary mx-10"
        >Integrar

        <v-progress-circular
          v-show="loading"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-btn>
    </div>

    <br />

    <div>
      <p>Status da Integração.</p>

      <textarea
        v-if="ans"
        v-model="ans"
        style="width: 100%; height: 600px; background-color: lightgray"
      >
      </textarea>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import DateInputDate from "../../components/fields/DateInputDate";
import DateInput from "../../components/fields/DateInput";
import roleIds from "../../../../libraries/strapi/rolesIds";
import stmarieApi from "../../../../libraries/stmarie/stmarieApi";
export default {
  name: "Integration1",
  props: ["priCod"],
  components: { DateInputDate, DateInput },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    filCod() {
      return this.$route.query.filCod;
    },
  },

  data() {
    return {
      filiais: ["01", "02", "03", "07", "20", "21", "22", "23", "24"],
      selectedFilial: "01",
      lastDate: "", //LastDate
      anomesDate: "", //Mes de refeência
      ans: ``,
      roleIds: roleIds,
      loading: false,
    };
  },
  async mounted() {
    this.lastDate = new Date().toISOString();
    this.anomesDate = new Date().toISOString().substring(0, 7);
    //  alert(this.anomesDate);
  },
  methods: {
    async getProcesses() {},

    async ctb(filial) {
      this.ans = "";
      this.loading = true;
      try {
        if (this.lastDate && this.selectedFilial && this.anomesDate) {
          let d = new Date(this.lastDate?.substring(0, 10));
          let year = this.anomesDate.substring(0, 4);
          let month = this.anomesDate.substring(5, 7);
          let anomes = `${year}${month}`;
          let d2 = new Date();

          let ans = await stmarieApi.ctb006_folha(filial, anomes, d.getTime());
          //this.ans = JSON.stringify(ans?.saida, null, 2);
          this.ans = JSON.stringify(ans, null, 2);
        } else {
          ///alert("Preencher todos os campos");
          throw new Error("Preencher todos os campos");
        }
      } catch (error) {
        this.ans = error;
      }

      this.loading = false;
    },
  },
};
</script>

<style></style>
